<template>
	<div class="detail">
		<expan-tip
			title="报名须知"
			content="1、暂不支持“取消报名”操作和查看团长审核结果，请到百应商家后台进行相关操作；2、实际已报名的商品，再次报名会提示“报名失败”，可以在“报名失败”列表手动设为已报名；3、由于服务费等原因报名失败的商品，可以在“报名失败”列表找到，并重新报名活动"
		/>
		<Panel :contentPaddingTop="12">
			<breadCrumb class="mb-12" />
			<div class="header flex-row-align-center pt-16 pb-16">
				<ButtonGroup>
					<div class="yx-color-text-primary flex-row-align-center font-h1-medium">
						<span>{{ row.activityTitle }}</span>
						<plainTag :isMarginBottom="false" class="ml-4" :type="row.activityType === 1 ? 'default' : 'primary'">
							{{ row.activityType === 1 ? '普通招商' : '专属招商' }}
						</plainTag>
					</div>
				</ButtonGroup>
				<ButtonGroup :lineHeight="8">
					<span class="ml-6">{{ row.activityUserNickName }}</span>
				</ButtonGroup>
			</div>
			<div class="font-h6-regular flex-row-align-center pt-12 pb-12">
				<ButtonGroup>
					<rdStatus :type="statusConfig(row).type"> {{ statusConfig(row).label }} </rdStatus>
				</ButtonGroup>
				<ButtonGroup :lineHeight="8">
					<span class="yx-color-text-placeholder">创建时间</span>
					<span class="yx-color-text-primary ml-4">{{ row.createTime | formatDate }}</span>
				</ButtonGroup>
				<ButtonGroup :lineHeight="8">
					<span class="yx-color-text-placeholder">活动时间</span>
					<span class="yx-color-text-primary ml-4">{{ row.activityBeginTime | formatDate }} 至 {{ row.activityEndTime | formatDate }}</span>
				</ButtonGroup>
			</div>
			<div class="flex-row">
				<div style="width: 500px" class="yx-border-top yx-border-left yx-border-right mr-24" v-if="userOpenInfo.length">
					<el-table
						header-cell-class-name="table-header-cell"
						row-class-name="table-row"
						:data="userOpenInfo"
						ref="cateListTable"
						class="table-small"
						max-height="355"
					>
						<el-table-column label="达人昵称" min-width="200">
							<template slot-scope="{ row }">
								<div class="font-h6-regular yx-color-text-primary">{{ row.name }}</div>
							</template>
						</el-table-column>
						<el-table-column label="达人账号" min-width="80">
							<template slot-scope="{ row }">
								<div class="font-h6-regular yx-color-text-primary">{{ row.userId }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="width: 500px; display: inline-block" class="yx-border-top yx-border-left yx-border-right">
					<el-table
						header-cell-class-name="table-header-cell"
						row-class-name="table-row"
						:data="categoryList"
						ref="cateListTable"
						class="table-small"
						max-height="355"
					>
						<el-table-column label="行业类目" min-width="200">
							<template slot-scope="{ row }">
								<div class="font-h6-regular yx-color-text-primary">{{ calcText(row.categorySortedByHierarchy, '>') }}</div>
							</template>
						</el-table-column>
						<el-table-column label="最低佣金要求" min-width="80">
							<template slot-scope="{ row }">
								<div class="font-h6-regular yx-color-text-primary">{{ row.minCommissionRate | formatPercent2 }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</Panel>
		<Panel>
			<el-tabs @tab-click="handleClick" v-model="tabName">
				<el-tab-pane v-for="(item, index) in tableArr" :label="item.label" :name="item.name" :key="index"> </el-tab-pane>
			</el-tabs>
			<div class="search">
				<ksSearch ref="search" :tabName="tabName" @onSubmit="onSubmit"></ksSearch>
			</div>
		</Panel>
		<Panel>
			<multi-table
				v-loading="loading"
				element-loading-text="加载中"
				element-loading-background="rgba(255, 255, 255)"
				ref="multiTable"
				:isEmptyObj="isEmptyObj"
				:columns="filterColumns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
			>
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</Panel>

		<!-- 抖音设置团长活动机制 -->
		<ksApplicationDrawer ref="ksApplicationDrawer" @refresh="refreshList" />

		<!-- 编辑报名 -->
		<editDialog ref="editDialog" @refresh="refreshList" />
	</div>
</template>
<script>
import { activityksDetail } from '@/api/secondColonelManage';
import { gen_text_img } from '@/utils/common';
import empty from '@/views/common/empty/index.vue';
import { permitApplyProductList, ksApplyProductList, cancelApply } from '@/api/secondColonelManage';
import editDialog from './components/editDialog.vue';
import ksSearch from './components/ksSearch.vue';
import { column_not, column_success } from './ksColumn';
import ksApplicationDrawer from './components/ksApplicationDrawer.vue';
import plainTag from '@/components/ui/plainTag';
import rdStatus from '@/components/ui/rdStatus';
import ButtonGroup from '@/components/ui/buttonGroup';
export default {
	name: 'detail',
	components: {
		empty,
		editDialog,
		ksSearch,
		ksApplicationDrawer,
		plainTag,
		rdStatus,
		ButtonGroup,
	},
	data() {
		return {
			tableArr: [
				{ label: '未报名商品', name: '0' },
				{ label: '已报名商品', name: '1' },
			],
			row: {},
			tabName: '0',
			signUp: '0',
			params: {
				page_index: 1,
				page_size: 10,
			},
			list: [],
			options: { selectable: false },
			isEmptyObj: {
				isEmpty: false,
				isEmptyShop: true,
				searchEmpty: false,
				isAuth: true,
			},
			column_not,
			column_success,
			total: '0',
			loading: true,
			isSearch: false,
			categoryList: [],
			userOpenInfo: [],
		};
	},
	created() {
		let signUp = this.$route.query.signUp || '0';
		this.tabName = signUp;
		this.signUp = signUp;
		this.activityksDetail();
		this.getProductList();
	},
	computed: {
		activityId() {
			return this.$route.query.id;
		},
		third_activity_id() {
			return this.$route.query.third_activity_id;
		},
		team_institution_id() {
			const { institution_info = {} } = this;
			return institution_info.team_institution_id || '';
		},
		filterColumns() {
			const { tabName, column_not, column_success } = this;
			return tabName === '0' ? column_not : column_success;
		},
		tableKeyArr() {
			const activity_category = {
				key: 'activity_category',
				column: [
					{ label: '商品类目', prop: 'category_names' },
					{ label: '佣金最低要求', prop: 'min_commission_rate', template: true },
				],
			};
			return [activity_category];
		},
		calcText() {
			return (list = [], str) => {
				return list.map(item => item.categoryName).join(str);
			};
		},
		authorityId() {
			return this.$route.query.authority_id || '';
		},
	},
	methods: {
		handleClick() {
			this.getProductList();
		},
		async activityksDetail() {
			const { activityId, authorityId: authority_id } = this;
			const data = await activityksDetail({ activityId, authority_id });
			this.row = data;
			this.categoryList = data.activityRuleSetViewOpenDto?.promotionActivityMarketingRule?.categoryCommissionRate || [];
			this.userOpenInfo = data.userOpenInfo || [];
		},
		async getProductList(isSearch) {
			const { tabName, authorityId: authority_id,activityId } = this;
			this.isSearch = Boolean(isSearch);
			this.loading = true;
			if (tabName === '0') {
				const data = await permitApplyProductList({ ...this.params, activityId, authority_id });
				this.list = data.list.map(item => {
					return {
						...item,
						tabName: tabName,
						operations: this.getButtons(item),
					};
				});
				this.total = `${data.page.item_total}`;
			} else {
				const data = await ksApplyProductList({ ...this.params, activityId, authority_id });
				this.list = data.list.map(item => {
					return {
						...item,
						tabName: tabName,
						operations: this.getButtons(item),
					};
				});
				this.total = `${data.page.item_total}`;
			}
			this.loading = false;
		},
		//操作按钮
		getButtons(item) {
			const { tabName, activityId ,authorityId} = this;
			let arr = [];
			arr.push(
				{
					label: tabName === '0' ? '报名' : '重新报名',
					type: 'text',
					classtype: 2,
					isShow: tabName == '0',
					click: row => {
						this.$refs.ksApplicationDrawer.show(row, activityId,authorityId);
					},
				},
				{
					label: '编辑',
					type: 'text',
					classtype: 2,
					isShow: tabName == '1' && item.itemAuditStatus === 1, //待审核状态下有编辑
					click: row => {
						this.$refs.editDialog.show(row,authorityId);
					},
				},
				{
					label: '取消推广',
					type: 'text',
					classtype: 2,
					isShow: tabName == '1' && item.itemAuditStatus === 2, //审核通过状态下有取消推广
					click: ({ itemId, preActivityId }) => {
						this.$modal({
							title: '提示',
							contentTitle: '是否确认取消推广',
							size: 'small',
						}).then(async res => {
							if (res.key == 'confirm') {
								await cancelApply({ preActivityId, itemId, activityId,authority_id: this.authorityiId });
								this.$message.success('操作成功！');
								this.refreshList();
								res.done();
							} else {
								res.done();
							}
						});
					},
				},
			);

			return arr.filter(item => item.isShow);
		},
		genTextImg(name) {
			let str = name ? name.slice(0, 1) : '无';
			return gen_text_img([60, 60], str);
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.getProductList(1);
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getProductList();
		},
		refreshList() {
			this.getProductList();
		},
		statusConfig({ activityStatus }) {
			const status = {
				1: {
					label: '未发布',
					type: 'warning',
				},
				2: {
					label: '已发布',
					type: 'success',
				},
				3: {
					label: '进行中',
					type: 'success',
				},
				4: {
					label: '失效',
					type: 'fail',
				},
				5: {
					label: '已删除',
					type: 'error',
				},
			};
			return status[activityStatus] || {};
		},
	},
};
</script>
<style lang="less" scoped>
.header {
	border-top: 1px solid @color-gy3;
	border-bottom: 1px solid @color-gy3;
}
.line::before {
	content: '';
	width: 1px;
	height: 12px;
	background-color: @color-gy4;
	margin: 0px 16px;
}
.text_img {
	width: 16px;
	height: 16px;
	border-radius: 50%;
}
/deep/ .el-table td.el-table__cell {
	border-bottom: 1px solid @border-color-base;
}
</style>
